export default __webpack_public_path__ + "static/custom-ux-plan-380002960bc1cfb016b372a2779dd66d.jpg";